<div *ngIf="resource" class="option">
  <span>{{ resource.label }}</span>
  <span *ngIf="resourceStatus">{{ resourceStatus.price + "kr" }}</span>
  <span *ngIf="resourceStatus" [ngClass]="{'availability': true, 'warning': (bookedResources || 0) > (resourceStatus.qty || 0)}">
    Bokade platser:
    {{ bookedResources + "/" + resourceStatus.qty }}
  <mat-icon *ngIf="(bookedResources || 0) > (resourceStatus.qty || 0)" matTooltip="Kapacitet överstigen">warning</mat-icon>  
  </span>
</div>
